import React from 'react';
import PropTypes from 'prop-types';
import Lottie from 'lottie-react';
import { withErrorBoundary, useErrorBoundary } from 'react-use-error-boundary';

const LottieComponent = withErrorBoundary(({ lottieJson, className = '' }) => {
    const { error, errorInfo } = useErrorBoundary();

    if (error) {
        console.error(error, errorInfo);
        return null;
    }

    return (
        <Lottie
            animationData={JSON.parse(lottieJson)}
            loop={true}
            autoplay={true}
            {...{ className }}
        />
    );
});

export default LottieComponent;

LottieComponent.propTypes = {
    lottieJson: PropTypes.string.isRequired,
    className: PropTypes.string
};
